import { changeActivePane as changeActivePaneDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import { SidebarTab } from '@process-advisor/process-miner/shared/consts';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

let prevSlicerPane = SidebarTab.variantsTab;

export type ActivePaneProps = ApiMethodBase & {
    pane: SidebarTab;
}

export const changeActivePane = ({ pane, diagram, eventEmitter }: ActivePaneProps) => {
    eventEmitter.emit(Event.changeActivePane, pane);
    changeActivePaneDiagram(pane);
    prevSlicerPane = pane as SidebarTab;
};

